import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import Pipes from './pipes';
import Services from './services';

@NgModule({
  imports: [CommonModule],
  declarations: [...Pipes],
  exports: [...Pipes],
  providers: [...Services],
})
export class UtilCommonModule {}
